export default {
  // Page title
  'page.title': 'Horloge Mondiale',

  // Time zones and cities
  'timezone.utc': 'UTC',
  'timezone.local': 'Heure Locale',
  'timezone.currentTime': 'Heure Actuelle',
  'timezone.label': 'Fuseau Horaire',
  'timezone.title': 'Fuseau Horaire de {{city}}',
  'timezone.localClockOffset': 'Décalage Horaire Local',
  'timezone.timeZone': 'Fuseau horaire',
  'timezone.today': 'Aujourd\'hui',
  'timezone.hours': 'H',
  'timezone.standardTimeZone': 'Fuseau Horaire Standard',
  'timezone.daylightSavingTimeZone': 'Fuseau Horaire d\'Été',

  // City names (keeping English as standard)
  'city.newYork': 'New York',
  'city.london': 'Londres',
  'city.paris': 'Paris',
  'city.tokyo': 'Tokyo',
  'city.sydney': 'Sydney',
  'city.dubai': 'Dubaï',
  'city.singapore': 'Singapour',
  'city.hongKong': 'Hong Kong',
  'city.shanghai': 'Shanghai',
  'city.beijing': 'Pékin',
  'city.mumbai': 'Bombay',
  'city.moscow': 'Moscou',
  'city.berlin': 'Berlin',
  'city.losAngeles': 'Los Angeles',
  'city.chicago': 'Chicago',
  'city.toronto': 'Toronto',
  'city.vancouver': 'Vancouver',
  'city.brasilia': 'Brasília',
  'city.buenosAires': 'Buenos Aires',
  'city.cairo': 'Le Caire',
  'city.istanbul': 'Istanbul',

  // How to use
  'howto.title': 'Comment Utiliser l\'Horloge Mondiale en Ligne',
  'howto.step1': 'Ce site d\'horloge mondiale affiche l\'heure actuelle et l\'heure mondiale pour n\'importe quelle ville du monde. Vérifiez les fuseaux horaires, les différences d\'heure mondiale et l\'heure internationale instantanément à travers le globe.',
  'howto.step2': 'La page d\'accueil de l\'horloge mondiale affiche votre heure locale ainsi que plusieurs horloges mondiales pour les grandes villes. Chaque fuseau horaire mondial affiche des informations précises sur l\'heure, la date et le décalage horaire.',
  'howto.step3': 'Cliquez sur n\'importe quel nom de ville dans la liste de l\'horloge mondiale pour voir des informations détaillées sur le fuseau horaire. Chaque page d\'heure mondiale fournit des données complètes sur le fuseau horaire et l\'heure actuelle pour cet emplacement.',
  'howto.step4': 'Utilisez la recherche de l\'horloge mondiale pour trouver l\'heure dans n\'importe quelle ville du monde. Parfait pour vérifier les fuseaux horaires mondiaux, la coordination de l\'heure internationale et les besoins de gestion du temps mondial.',

  // User reviews
  'reviews.title': 'Avis des Utilisateurs',
  'reviews.globalBusiness': 'Essentiel pour les affaires internationales ! Facile de coordonner les heures de réunion à travers différents fuseaux horaires, très pratique.',
  'reviews.travelBlogger': 'Indispensable pour la planification de voyage ! Je connais toujours l\'heure locale à ma destination, plus de confusion avec le décalage horaire.',
  'reviews.remoteTeam': 'Parfait pour la collaboration d\'équipe à distance ! Facile de voir quand les collègues dans différents pays travaillent.',
  'reviews.internationalFamily': 'Idéal pour rester connecté avec la famille à l\'étranger ! Je sais toujours le meilleur moment pour appeler sans déranger leur sommeil.',
  'reviews.managerZhang': 'En tant que chef de projet, cela m\'aide à planifier les réunions avec les clients mondiaux plus efficacement.',

  // User names
  'user.globalBusiness': 'Affaires Mondiales',
  'user.travelBlogger': 'Blogueur Voyage',
  'user.remoteTeam': 'Développeur Distant',
  'user.internationalFamily': 'Famille Internationale',
  'user.managerZhang': 'Manager Zhang',

  // Keywords
  'keywords.worldclock': 'horloge mondiale fuseaux horaires heure internationale quelle heure',
  'keywords.chinese': '世界时钟 时区 国际时间 现在几点',
  'keywords.japanese': '世界時計 タイムゾーン 国際時間 今何時',
  'keywords.spanish': 'reloj mundial zonas horarias tiempo internacional qué hora',
  'keywords.german': 'Weltzeituhr Zeitzonen internationale Zeit wie spät',
  'keywords.french': 'horloge mondiale fuseaux horaires temps international quelle heure',
  'keywords.russian': 'мировые часы часовые пояса международное время который час',

  // Country related
  'countriesTime': 'Heure par Pays',
  'timeIn': 'Heure à',
  'cities': 'villes',
  'available': 'disponibles',
  'citiesIn': 'Villes en',
  'viewDetails': 'Voir les détails',
  'countryNotFound': 'Pays non trouvé',
  'backToWorldClock': 'Retour à l\'Horloge Mondiale',
  'cityNotFound': 'Ville non trouvée',
  'popularCitiesIn': 'Villes Populaires en',
  'currentTime': 'Heure Actuelle',
};